export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100"></div>
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 25%, oklch(0.75 0.16 82 / 0.3) 0%, transparent 50%), radial-gradient(circle at 75% 75%, oklch(0.65 0.18 25 / 0.2) 0%, transparent 50%)',
        }}
      ></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-400">每日更新 · 片源充足</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-wide">
              久播影院 · 高清免费在线观影
            </h1>

            <p className="mt-3 text-lg md:text-xl text-primary-400 font-heading font-semibold tracking-wider">
              不缓冲 · 不卡顿 · 不收费
            </p>

            <div className="mt-5 space-y-3">
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
                久播影院是专注高清影视的免费在线观影平台，每日同步更新海内外热门电影、高分剧集、经典老片与热门综艺。采用全球CDN加速与智能码率适配技术，无论宽带还是移动网络，都能畅享零等待的流畅观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
                当前暑期档热片云集，《流浪地球3》《长风渡》等高口碑作品均已上线4K版本。平台持续优化片源质量与播放体验，致力于让每一位影迷都能轻松找到心仪好片。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/15">
                  <i className="ri-movie-line text-lg text-primary-400"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-800 font-heading">10万+</div>
                  <div className="text-xs text-foreground-500">影视资源</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500/15">
                  <i className="ri-user-smile-line text-lg text-accent-400"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-800 font-heading">5000万+</div>
                  <div className="text-xs text-foreground-500">月活跃用户</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/15">
                  <i className="ri-4k-line text-lg text-primary-400"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-800 font-heading">4K HDR</div>
                  <div className="text-xs text-foreground-500">画质标准</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-background-200/80 hover:bg-background-300/70 text-foreground-700 font-medium text-sm rounded-full border border-background-300/60 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-apps-line mr-2"></i>
                浏览全部分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 rounded-2xl bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-primary-500/10 blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/40 bg-background-100">
                <div className="aspect-[4/3] relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20velvet%20red%20curtains%2C%20empty%20theater%20seats%20with%20dramatic%20spotlight%20effect%2C%20luxurious%20and%20atmospheric%20cinema%20hall%2C%20professional%20photography%20with%20rich%20contrast%20and%20deep%20shadows%2C%20warm%20amber%20and%20burgundy%20color%20palette%2C%20elegant%20and%20sophisticated%20mood&width=1200&height=900&seq=hero-cinema-2026&orientation=landscape"
                    alt="久播影院高清影视观影体验"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-100/60 via-transparent to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <div className="flex items-center gap-2">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">LIVE</span>
                    <span className="text-sm text-foreground-300">当前 128.6万 人在线观看</span>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-4 -right-4 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-background-100 border border-background-300/40 flex flex-col items-center justify-center shadow-[0_8px_30px_rgba(0,0,0,0.3)]">
                <span className="text-xl md:text-2xl font-heading font-bold text-primary-400">99.9%</span>
                <span className="text-[10px] md:text-xs text-foreground-500">服务可用率</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}